import React, { useState, useEffect, useCallback } from 'react'
import WeekPopover from './weekpopover'
import useDeepCompareEffect from 'use-deep-compare-effect'
import { fleetactAction } from '@/store/actions/fleetactAction'
import { fleetacthistoryAction } from '@/store/actions/fleetacthistoryAction'
import { getWeek } from '@/utils/utils'
import { connect } from 'react-redux'
import BScroll from '@/components/bs';
import NoConfig from '@/components/noconfig'
import noconf from '@/assets/images/noconf.png'
import nohistory from '@/assets/images/nohistory.png'
import allno from '@/assets/images/allno.png'
import './index.scss'

const mapStateToProps = (state) => ({
    activityOverAllFlag: state.getIn(['fleetactReducer', 'activityOverAllFlag']),
    // 奖励金额
    awardMoney: state.getIn(['fleetactReducer', 'awardMoney']),
    // 奖励金额计算方式百分比
    awardRule: state.getIn(['fleetactReducer', 'awardRule']),
    // 车队达成天数
    reachDayReality: state.getIn(['fleetactReducer', 'reachDayReality']),
    // 车队达成目标天数
    reachDayTarget: state.getIn(['fleetactReducer', 'reachDayTarget']),
    // 车队完成天数某天完成情况
    taskReachDayList: state.getIn(['fleetactReducer', 'taskReachDayList']),
    // 车队历史奖励数据
    fleetactArr: state.getIn(['fleetacthistoryReducer', 'fleetactArr']),
    // 车队历史总数据
    total: state.getIn(['fleetacthistoryReducer', 'total']),
    // 车队是否配置任务
    activityConfig: state.getIn(['fleetactReducer', 'activityConfig']),
})
const mapDispatchToProps = (dispatch) => ({
    handleGetFleetAct() {
        return dispatch(fleetactAction());
    },
    handleGetActHistory(params) {
        return dispatch(fleetacthistoryAction(params));
    }
})
const FleetAwardPage = ({
    handleGetFleetAct,
    awardMoney,
    awardRule,
    reachDayReality,
    reachDayTarget,
    taskReachDayList,
    handleGetActHistory,
    fleetactArr,
    activityOverAllFlag,
    total,
    activityConfig }) => {
    // 每周任务列表数据
    let [taskList, setTaskList] = useState([]);
    let pageCount = 1;
    // 周数
    let week = ['一', '二', '三', '四', '五', '六', '日']
    // 获取数据
    useEffect(() => {
        handleGetFleetAct()
        handleGetActHistory({
            pageNo: 1,
            pageSize: 10
        });
        return () => { }
    }, [handleGetFleetAct, handleGetActHistory])
    useDeepCompareEffect(() => {
        setTaskList(() => {
            let newArr = []
            fleetactArr.forEach((item, index) => {
                let obj = {
                    date: `${item.startDate.substr(0, 10)} 至 ${item.endDate.substr(0, 10)}`,
                    finishDay: item.reachNumberDay,
                    shareProportion: item.awardRule,
                    shareMoney: item.awardMoney,
                    standard: item.flag
                }
                newArr.push(obj);
            })
            return [...taskList, ...newArr]
        })

    }, [fleetactArr])
    // better-scroll 配置项
    const bsconfig = {
        scrollY: true,
        scrollX: false,
        click: true,
        probeType: 3,
        bounce: {
            top: false,
        },
        deceleration: 0.001,
        pullUpLoad: {
            threshold: -100  //当上拉距离超过50px时触发 pullingUp 事件
        }
    }
    const handlepullingUp = useCallback(() => {
        pageCount += 1
        handleGetActHistory({
            pageNo: pageCount,
            pageSize: 10
        });
    }, [])
    // 当周完成任务
    let [isFinish, setIsFinish] = useState([]);
    useDeepCompareEffect(() => {
        setIsFinish(() => {
            let newArr = [
                {
                    date: getWeek(0),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(1),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(2),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(3),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(4),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(5),
                    activityFlag: false,
                    payableAmount: 0,
                },
                {
                    date: getWeek(6),
                    activityFlag: false,
                    payableAmount: 0,
                },
            ]
            taskReachDayList.forEach((item, index) => {
                // newArr.splice(index,1,item);
                let strDate = item.reachDate[8] + item.reachDate[9]
                newArr.forEach((el, i) => {
                    if (Number(el.date) === Number(strDate)) {
                        el.activityFlag = item.activityFlag
                        el.payableAmount = item.payableAmount
                    }
                })
            });
            return [...newArr]
        })
        return () => { }
    }, [taskReachDayList])
    return (
        <div className="fleet-award-page__box">
            <div className="fleet-award__show">
                {activityConfig === false && taskList.length <= 0 ? <NoConfig imgSrc={allno} txt={'活动配置中，敬请期待～'} stylecof={{ width: '3.4667rem', height: '3.4667rem' }} txtc={'#666'} /> :
                    <BScroll data={taskList} bsconfig={bsconfig} handlepullingUp={handlepullingUp} total={total}>
                        <div className="fleet-award__scroll">
                            {/* 任务卡片 */}
                            <div className="task-finish-info__card">
                                {
                                    activityConfig ?
                                        <div>
                                            <div className="task-top-target">
                                                <h5>
                                                    <em>{reachDayReality}</em>
                                                    <b> / {reachDayTarget}天</b>
                                                </h5>
                                                <h6>
                                                    {activityOverAllFlag ? '恭喜，本周任务完成～' : '本周奖励尚未达成，继续加油哦～'}
                                                </h6>
                                            </div>
                                            <div className="task-week-info">
                                                <div className="week-date">
                                                    {
                                                        week.map((item, index) => (
                                                            <span key={index}>{item}</span>
                                                        ))
                                                    }
                                                </div>
                                                <WeekPopover isFinish={isFinish} />
                                            </div>

                                            {/* 奖励规则信息 */}
                                            <h3>奖励金额 = 本周车队订单总收款 * {awardRule}% ，当前车队订单总收款金额: {awardMoney}元</h3>
                                        </div> : <NoConfig imgSrc={noconf} txt={'本周暂无活动～'} imgstyle={{ width: '2.4267rem', height: '2.4267rem' }} />
                                }
                            </div>
                            {/* 每周状态 */}
                            <div className="week-status__box">
                                <h2 className="week-status__tit">历史奖励</h2>
                                {
                                    taskList.length > 0 ?
                                        taskList.map((item, index) => {
                                            return (
                                                <div className='week-status__list' key={index}>
                                                    <h3><i className="iconfont2 icon-shijian"></i>{item.date}</h3>
                                                    <p>
                                                        {
                                                            item.standard ? <i className="iconfont2 icon-duihao"></i> : <i className="iconfont2 icon-dingdan"></i>
                                                        }
                                                        车队达标{item.finishDay}天,
                                                        {item.standard ? `分润比例${item.shareProportion || 0}%，分润金额${item.shareMoney || 0}元。` : '整体未达标。'}
                                                    </p>
                                                </div>
                                            )
                                        })
                                        : <NoConfig imgSrc={nohistory} txt={'暂无历史奖励～'} stylecof={{ width: '3.4667rem', height: '3.4667rem' }} txtc={'#666'} />
                                }
                            </div>
                        </div>
                    </BScroll>
                }
            </div>
        </div>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(FleetAwardPage)